export enum DeleteMode {
  NoActivityBooking = "NO_ACTIVITY_BOOKING",
  MultipleBookings = "MULTIPLE_BOOKINGS",
  LastBooking = "LAST_BOOKING"
}
